import { Alert, Button, TextField } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";

const AddProductPage = () =>
{
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [barcode, setBarcode] = useState('');
    const [description, setDescription] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = () => {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'name': name,
                'barcode': barcode,
                'description': description
            })
        };
        fetch('/api/product', requestOptions)
        .then(async response => {
            const json = await response.json();
            if(!response.ok) throw new Error(json.message);
            return json;
        })
        .then(e => navigate('/product', {state: {message: 'Das Produkt wurde erfolgreich hinzugefügt.'}}))
        .catch(error => {
            setErrorMessage(error.message);
            console.error(error);
        });
    }

    return(
        <div className="centered">
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={evt => window.location.assign('/product')}>zurück</Button> 
            <h2>Produkt hinzufügen</h2>
            <TextField 
                fullWidth
                label="Name"
                required
                onChange={(event) => setName(event.target.value)} 
                value={name}
            />
            <TextField 
                fullWidth
                label="Barcode" 
                onChange={(event) => setBarcode(event.target.value)} 
                value={barcode}
            />
            <TextField
                fullWidth
                label="Beschreibung"
                multiline
                margin="normal" // or "dense"
                onChange={(event) => setDescription(event.target.value)} 
                value={description}
                placeholder="Beschreibung des Produkts (z.B. Menge)"
            />
            {errorMessage !== '' && <Alert severity="error">{errorMessage}</Alert>}
            <Button sx={{marginLeft:'15px !important'}} fullWidth className={'custom-button-root'} onClick={() => handleSubmit()}>Hinzufügen</Button>
        </div>
    );
};

export default AddProductPage;